import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";

@Component({
    selector: 'company-events-notes',
    templateUrl: './company-events-notes.component.html',
    styleUrls: ['./company-events-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsNotesComponent implements  OnInit{

  isEditMode: boolean = false;
  @Input() note: any;
  @Input() userCanEdit:boolean;
  @Output() updateNote: EventEmitter<string> = new EventEmitter<string>()
  noteForm: FormGroup = new FormGroup({
    noteControl: new FormControl(null)
  })

  ngOnInit(){
    if(this.note!==null){
      this.noteForm.controls['noteControl'].setValue(this.note)
    }
  }

  editToggle(){
    if(this.isEditMode && this.noteForm.touched){
      this.note = this.noteForm.controls['noteControl'].value
      this.updateNote.emit(this.noteForm.controls['noteControl'].value)
    }
    this.isEditMode = !this.isEditMode
  }
}
